<template>
  <div id="speedTestPage">
    <div class="speedTestWrapper">
      <template v-if="currentPage == 'speedTest'">
        <el-container>
          <el-header>
            <h2>网速测试</h2>
          </el-header>
          <el-main>
            <div class="toolbar">
              <el-button type="success" :disabled="startBtnOff" @click="startTest">{{ startBtnName }}</el-button>
              &emsp;&emsp;
              <span class="test-result">测试结果：</span>
              <span class="download-result">下行速率：{{ avgDownSpeed }}</span>
              &emsp; &emsp;
              <span class="upload-result">上行速率：{{ avgUpSpeed }}</span>
              &emsp; &emsp;
              <span class="upload-network">RTT(延时)：{{ rtt }}</span>
              &emsp; &emsp;
              <span class="upload-network">预计带宽（MB）：{{ downlink }}</span>
              &emsp; &emsp;
              <span class="upload-network">网络类型：{{ effectiveType }}</span>
            </div>
            <div class="result-panel">
              <el-table :data="downloadResult" style="width: 100%">
                <el-table-column prop="downloadSpeed" label="下行速率 (KB/S)" width="180">
                </el-table-column>
                <el-table-column prop="time" label="时间" width="180">
                </el-table-column>
                <el-table-column prop="consume" label="耗时(S)">
                </el-table-column>
              </el-table>
            </div>
            <div class="result-panel">
              <el-table :data="uploadResult" style="width: 100%">
                <el-table-column prop="uploadSpeed" label="上行速率 (KB/S)" width="180">
                </el-table-column>
                <el-table-column prop="time" label="时间" width="180">
                </el-table-column>
                <el-table-column prop="consume" label="耗时(S)">
                </el-table-column>
              </el-table>
            </div>
          </el-main>
        </el-container>
      </template>
    </div>
  </div>
</template>
<script>
import axios from "axios";

function formatDateTime (date) {
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let minute = date.getMinutes();
  minute = minute < 10 ? "0" + minute : minute;
  let second = date.getSeconds();
  second = second < 10 ? "0" + second : second;
  return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
}

// 计算字节数
function sizeOf (str, charset) {
  let total = 0;
  let charCode;
  let i;
  let len;
  charset = charset ? charset.toLowerCase() : "";
  if (charset === "utf-16" || charset === "utf16") {
    for (i = 0, len = str.length; i < len; i++) {
      charCode = str.charCodeAt(i);
      if (charCode <= 0xffff) {
        total += 2;
      } else {
        total += 4;
      }
    }
  } else {
    for (i = 0, len = str.length; i < len; i++) {
      charCode = str.charCodeAt(i);
      if (charCode <= 0x007f) {
        total += 1;
      } else if (charCode <= 0x07ff) {
        total += 2;
      } else if (charCode <= 0xffff) {
        total += 3;
      } else {
        total += 4;
      }
    }
  }
  return total;
}

function parseUrl () {
  let protocol = window.location.protocol;
  let host = window.location.host;
  return protocol + "//" + host;
}

export default {
  data () {
    return {
      currentPage: "speedTest",
      downloadResult: [],
      uploadResult: [],
      runCount: 0,
      runUpCount: 0,
      downlink: 0,
      rtt: 0,
      effectiveType: "",

      startBtnName: "启动网速测试"
    };
  },
  mounted () {
    this.watchConnection();
  },
  methods: {
    startTest () {
      this.runCount = 0;
      this.runUpCount = 0;
      this.startBtnName = "测试中，请稍后...";
      this.downloadResult = [];
      this.uploadResult = [];
      this.downloadTest();
      this.uploadTest();
    },
    getFrontPath () {
      let FONT_PATH = "../../static/assets/font";
      if (process.env.NODE_ENV === "production") {
        // let fontPath = trim((process.env.SERVER_PATH || "").split("##")[0]);
        let fontPath = this.$basecfg.httpConfig.fontUrl;
        if (fontPath.length) FONT_PATH = fontPath;
      }
      return FONT_PATH;
    },
    downloadTest () {
      const fileSize = 4096; // 4MB = 4096 KB
      let startTime = new Date();
      // let  fontPath = this.getFrontPath(),
      let urlPre = process.env.BASE_URL ? process.env.BASE_URL : parseUrl();
      axios
        //  .get(fontPath + "/MicrosoftYaHei-Bold.eot?t=" + new Date())
        .get(
          urlPre +
          "/vtm/vtm_network_speed?t=" +
          Math.floor(Math.random() * 10000)
        )
        .then((response) => {
          let endTime = new Date();
          let consumeTime = (endTime - startTime) / 1000;
          let speed = fileSize / consumeTime;
          this.downloadResult.push({
            downloadSpeed: speed.toFixed(2),
            time: formatDateTime(new Date()),
            consume: consumeTime.toFixed(2)
          });
          this.runCount++;
          if (this.runCount < 5) {
            setTimeout(() => {
              this.downloadTest();
            }, 200);
          }
        })
        .catch((error) => {
          this.runCount = 5;
          const h = this.$createElement;
          this.$notify({
            title: "下行网速测试异常",
            message: h("i", { style: "color: teal" }, "")
          });
        });
    },
    uploadTest () {
      let arrData = [];
      let strData;
      let startTime;
      let fileSize;
      let urlPre = process.env.BASE_URL ? process.env.BASE_URL : parseUrl();

      for (let i = 0; i < 1048576; i++) {
        arrData.push("A");
      }
      strData = arrData.join("");

      fileSize = sizeOf(strData, "utf8") / 1024; // 单位KB
      // fileSize = 1067.7;
      startTime = new Date();
      axios
        .post(urlPre + "/vtm/vtm_network_speed", { test: strData })
        /* this.$syscfg
          .K_Request("F0000000", {
            SERVICE_CODE: "QS4000024",
            test: strData,
          }) */
        .then((response) => {
          let endTime = new Date();
          let consumeTime = (endTime - startTime) / 1000;
          let speed = fileSize / consumeTime;
          this.uploadResult.push({
            uploadSpeed: speed.toFixed(2),
            time: formatDateTime(new Date()),
            consume: consumeTime.toFixed(2)
          });
          this.runUpCount++;
          if (this.runUpCount < 5) {
            setTimeout(() => {
              this.uploadTest();
            }, 200);
          }
        })
        .catch((error) => {
          this.runUpCount = 5;
          const h = this.$createElement;
          this.$notify({
            title: "上行网速测试异常",
            message: h("i", { style: "color: teal" }, "")
          });
        });
    },
    watchConnection () {
      navigator.connection.addEventListener("change", () => {
        const conn = navigator.connection;
        this.downlink = conn.downlink;
        this.rtt = conn.rtt;
        this.effectiveType = conn.effectiveType;
      });
    }
  },
  computed: {
    startBtnOff () {
      let count = this.runUpCount + this.runCount;
      if (count >= 10 || count === 0) {
        this.startBtnName = "启动网速测试";
        return false;
      } else {
        this.startBtnName = "测试中，请稍后...";
        return true;
      }
    },
    avgUpSpeed () {
      let arrSpeed = [];
      if (this.runUpCount < 5) {
        return "0 KB/S";
      }
      arrSpeed = this.uploadResult.map((v) => Number(v.uploadSpeed)).sort();
      return arrSpeed[2] + " KB/S";
    },
    avgDownSpeed () {
      let arrSpeed = [];
      if (this.runCount < 5) {
        return "0 KB/S";
      }
      arrSpeed = this.downloadResult.map((v) => Number(v.downloadSpeed)).sort();
      return arrSpeed[2] + " KB/S";
    }
  }
};
</script>
<style scoped>
div.speedTestWrapper {
  margin: 0 90px;
  height: 100%;
  background-color: #ffffff;
}
h2 {
  color: #f3240f;
}
.toolbar > button > span {
  font-size: 1.5rem;
}
span.test-result {
  color: #3538e2;
}
span.download-result {
  color: #8ab11f;
}
span.upload-result {
  color: #eb1dd9;
}
span.upload-network {
  color: #e28535;
}
</style>


// WEBPACK FOOTER //
// src/pages/speedTest/speedTest.vue